import APIRequestState from '../_util/api-request';

class SignupV2State extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/v2/users'; }
}

export default SignupV2State;



// WEBPACK FOOTER //
// ./spa/state/session/signupV2.jsx